(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(heroEl) {
    if (!heroEl.dataset.slider) return;

    var slides   = Array.from(heroEl.querySelectorAll('.hero__slide'));
    var dots     = Array.from(heroEl.querySelectorAll('.hero__dot'));
    var prevBtn  = heroEl.querySelector('.hero__arrow--prev');
    var nextBtn  = heroEl.querySelector('.hero__arrow--next');
    var autoplay = heroEl.dataset.sliderAutoplay === 'true';
    var interval = parseInt(heroEl.dataset.sliderInterval, 10) || 7000;
    var current  = 0;
    var timer    = null;

    if (slides.length < 2) return;

    function goTo(index) {
      slides[current].classList.remove('hero__slide--active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('hero__dot--active');
        dots[current].setAttribute('aria-current', 'false');
      }

      current = ((index % slides.length) + slides.length) % slides.length;

      slides[current].classList.add('hero__slide--active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('hero__dot--active');
        dots[current].setAttribute('aria-current', 'true');
      }
    }

    function start() {
      if (!autoplay) return;
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    function stop() { clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { stop(); goTo(current - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stop(); goTo(current + 1); start(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { stop(); goTo(i); start(); });
    });

    heroEl.addEventListener('mouseenter', stop);
    heroEl.addEventListener('mouseleave', start);

    // Touch swipe
    var touchX = 0;
    heroEl.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX; stop();
    }, { passive: true });
    heroEl.addEventListener('touchend', function (e) {
      var diff = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
      start();
    }, { passive: true });

    // Keyboard
    heroEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stop(); goTo(current - 1); start(); }
      if (e.key === 'ArrowRight') { stop(); goTo(current + 1); start(); }
    });

    start();
  }

  document.querySelectorAll('.hero[data-slider="true"]').forEach(initSlider);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var hero = e.target.querySelector('.hero[data-slider="true"]');
      if (hero) initSlider(hero);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
